import React, { useState } from 'react';
import { PLAN_TYPES } from './planTypes';

function tierClass(id) {
  if (id === 'karma') return 'yoga-tier yoga-tier--karma';
  if (id === 'guided') return 'yoga-tier yoga-tier--guided';
  if (id === 'teacher') return 'yoga-tier yoga-tier--teacher';
  return 'yoga-tier yoga-tier--guided';
}

/**
 * Choose Karma / Guided / Teacher. Used for first-visit onboarding and Membership.
 */
export default function PlanPicker({
  currentPlanType = null,
  onSelect,
  busy = false,
  showPrices = false,
  showBrand = true,
  title = 'Choose your plan',
  lead = 'Pick how you want to use YogaKai. You can change this later in Membership.',
}) {
  const [pending, setPending] = useState(null);

  const choose = async (id) => {
    if (busy || pending) return;
    setPending(id);
    try {
      await onSelect(id);
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="yoga-plan-picker u-stack m-fade-in" style={{ '--gap': 'var(--sp-5)' }}>
      {(showBrand || title || lead) ? (
        <header className="yoga-page-head">
          {showBrand ? <p className="yoga-eyebrow">YogaKai</p> : null}
          {title ? <h2 className="yoga-hero-title">{title}</h2> : null}
          {lead ? <p className="yoga-hero-lead">{lead}</p> : null}
        </header>
      ) : null}

      <div className="yoga-plan-grid" role="list">
        {PLAN_TYPES.map((plan) => {
          const selected = currentPlanType === plan.id;
          const working = pending === plan.id;
          return (
            <button
              key={plan.id}
              type="button"
              role="listitem"
              className="yoga-plan-card"
              aria-pressed={selected}
              disabled={busy || !!pending}
              onClick={() => choose(plan.id)}
            >
              <div className="u-cluster" style={{ '--gap': '8px', alignItems: 'center' }}>
                <span className={tierClass(plan.id)}>{plan.label}</span>
                {selected ? <span className="cs-badge">Current</span> : null}
              </div>
              {showPrices && plan.priceLabel ? (
                <div className="yoga-plan-card__price">
                  {plan.priceLabel}
                  {plan.priceLabel.includes('/') ? null : (
                    <small>{plan.id === 'karma' ? ' forever' : ''}</small>
                  )}
                </div>
              ) : (
                <div className="yoga-plan-card__name">{plan.label}</div>
              )}
              <p className="u-muted u-small" style={{ margin: 0, lineHeight: 1.5 }}>
                {plan.blurb}
              </p>
              {plan.features?.length ? (
                <ul>
                  {plan.features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
              ) : null}
              <span className={`cs-btn ${selected ? '' : 'primary'} yoga-plan-cta`}>
                {working ? 'Saving…' : selected ? 'Keep this plan' : 'Choose'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
